module.exports = __webpack_public_path__ + "img/Integrate Communication.baea059c.svg";